import { useCallback, useEffect, useState } from 'react';
import debounce from '@hugsmidjan/qj/debounce';

type Sizes = {
  width: number;
  height: number;
  isTablet: boolean | undefined;
  isPhone: boolean | undefined;
};

export const useResize = () => {
  const [sizes, setSizes] = useState<Sizes>({
    width: 0,
    height: 0,
    isTablet: undefined,
    isPhone: undefined,
  });

  const handleResize = useCallback(() => {
    setSizes({
      width: window.innerWidth,
      height: window.innerHeight,
      isTablet: window.matchMedia('(max-width: 1079px)').matches,
      isPhone: window.matchMedia('(max-width: 700px)').matches,
    });
  }, []);

  useEffect(() => {
    handleResize();
    window.addEventListener('resize', debounce(handleResize, 100));

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [handleResize]);

  return sizes;
};
